
export const ROOT_PATH = '/' // public page

const constants = {
  ROOT_PATH,
}

export default constants